// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__k0pkQ","red":"Circle_red__Ta+jE","blue":"Circle_blue__asJXo","inside":"Circle_inside__-OMft"};